import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';
import './Testimonials.css';
import ladyImage from '../images/testmonials/25lady.webp';
import menImage from '../images/testmonials/25men.webp';
import men30Image from '../images/testmonials/30men.jpeg';
import women50Image from '../images/testmonials/50women.jpg';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      role: 'Son of Patient',
      image: men30Image,
      rating: 4,
      text: 'Aroghya Radham has been a blessing for our family. The caregivers are professional, compassionate, and genuinely care about my mother\'s well-being. Highly recommended!'
    },
    {
      name: 'Priya kumari',
      role: 'Daughter of Patient',
      image: ladyImage,
      rating: 5,
      text: 'Excellent home care services! The nurses are well-trained and the support staff is always available. My father feels comfortable and well-cared for at home.'
    },
    {
      name: 'Arun Venkatesh',
      role: 'Family Member',
      image: menImage,
      rating: 5,
      text: 'We are extremely satisfied with the physiotherapy services. The therapist is knowledgeable and patient. My grandmother has shown remarkable improvement.'
    },
    {
      name: 'Lakshmi Devi',
      role: 'Patient',
      image: women50Image,
      rating: 4,
      text: 'The palliative care team is exceptional. They provide not just medical care but emotional support too. Thank you for making this difficult time easier for us.'
    }
  ];

  return (
    <section className="testimonials-section">
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">Real experiences from families we've served</p>
        </div>
        
        <Row className="g-4">
          {testimonials.map((testimonial, index) => (
            <Col key={index} lg={3} md={6}>
              <Card className="testimonial-card h-100">
                <Card.Body className="d-flex flex-column">
                  <div className="testimonial-header text-center mb-3">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      className="testimonial-avatar"
                    />
                    <h5 className="mt-3 mb-1">{testimonial.name}</h5>
                    <p className="testimonial-role">{testimonial.role}</p>
                    <div className="rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <FaStar key={i} className="star-icon" />
                      ))}
                    </div>
                  </div>
                  <p className="testimonial-text flex-grow-1">"{testimonial.text}"</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Testimonials;
